<script lang="tsx">
import { defineComponent, watch, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { useFetch } from '@/hooks/useFetch'
import { API_GROUP_AGREEMENT_ALL } from '@/api/groupAgreement'
import { genSimpleConditionItem } from '@/hooks/useConditions'
import { Table, type TableColumnType } from 'ant-design-vue'
import { FileDisplaySimples } from '../Common/FileDisplay'
const [name] = createNamespace('GroupAgreementSimpleTable')
export default defineComponent({
  name,
  props: {
    pId: {
      type: String as PropType<string>
    }
  },
  setup(props) {
    const { loading, result, fetchData } = useFetch({
      getFn: API_GROUP_AGREEMENT_ALL,
      isShallow: true
    })
    const columns: TableColumnType[] = [
      {
        title: '被征收方（村社）',
        dataIndex: 'villageName'
      },
      {
        title: '征收集体土地补偿协议',
        dataIndex: 'village0Files',
        width: 300,
        customRender({ text = [] }) {
          return <FileDisplaySimples files={text} colAttrs={{ span: 24 }} />
        }
      }
    ]
    watch(
      () => props.pId,
      nval => {
        if (nval) {
          fetchData({
            conditions: [genSimpleConditionItem('projectId', nval)]
          })
        }
      },
      {
        immediate: true
      }
    )
    return () => (
      <Table pagination={false} loading={loading.value} dataSource={result.value} rowKey='id' scroll={{ y: 300 }} size='small' columns={columns} />
    )
  }
})
</script>
